import axios from "axios";
import config from "../../env.json";


export interface Client {
  id?: string;
  cloneId?: number;
  clientId: string;
  clientName: string;
}

// export function getBaseTenants(): Promise<Tenant[]> {
//   return new Promise((resolve, reject) => {
//     axios
//       .get(config.REACT_APP_ENV_API_BASE + "/templates/getClientTemplates", {
//         // headers: { "ngrok-skip-browser-warning": "69420" },
//       })
//       .then((res) => {
//         console.log("Raw API response:", res.data);
//         let data;
//         if (res.data && typeof res.data === "object") {
//           if (res.data.message === "No Data Found") {
//             console.log("API returned 'No Data Found'");
//             resolve([]);
//             return;
//           }
//           if (Array.isArray(res.data)) {
//             data = res.data;
//           } else if (
//             Array.isArray(res.data) &&
//             res.data[0] &&
//             res.data[0].JsonResult
//           ) {
//             try {
//               data = JSON.parse(res.data[0].JsonResult);
//             } catch (e) {
//               console.error("Error parsing JsonResult:", e);
//               data = res.data;
//             }
//           } else {
//             data = res.data;
//           }
//         } else {
//           console.warn("Unexpected API response format:", res.data);
//           resolve([]);
//           return;
//         }
//         console.log("Processed data for mapping:", data);
//         let mappedData: Tenant[] = [];

//         if (Array.isArray(data)) {
//           mappedData = data.map((config) => {
//             const tenants = config.Tenants || [];
//             return {
//               id: config.Id || "",
//               clientId: config.Client_Id || "",
//               clientName: config.Client_Nm || "",
//               clientEnvConfigId: config.ClientEnvConfig_Id || "",
//               clientConfigUrl: Array.isArray(tenants)
//                 ? tenants.map((t: any) => t.ClientConfig_Url)
//                 : [],
//               //config.ClientConfig_Url || "",
//               zone: config.ClientAzure_Zn || "",
//               clientSize: Array.isArray(tenants)
//                 ? tenants.map((t: any) => t.Client_Size)
//                 : [],
//               //config.Client_Size || "",
//               services: Array.isArray(tenants)
//                 ? tenants.map((t: any) => t.ClientService_Typ)
//                 : [],
//             };
//           });
//         } else if (data && typeof data === "object") {
//           const tenants = data.Tenants || [];
//           mappedData = [
//             {
//               id: data.Id || "",
//               clientId: data.Client_Id || "",
//               clientName: data.Client_Nm || "",
//               clientEnvConfigId: data.ClientEnvConfig_Id || "",
//               clientConfigUrl: Array.isArray(tenants)
//                 ? tenants.map((t: any) => t.ClientConfig_Url)
//                 : [],
//               //data.ClientConfig_Url || "",
//               zone: data.ConfigAzure_Zn || "",
//               clientSize: Array.isArray(tenants)
//                 ? tenants.map((t: any) => t.Client_Size)
//                 : [],
//               //data.Client_Size || "",
//               services: Array.isArray(tenants)
//                 ? tenants.map((t: any) => t.ClientService_Typ)
//                 : [],
//             },
//           ];
//         }

//         console.log("Final mapped data:", mappedData);
//         resolve(mappedData);
//       })
//       .catch((error) => {
//         console.error("API request failed:", error);
//         reject(error);
//       });
//   });
// }
export async function createDeployment(payload: any, callback: any) {
  try {
    await axios({
      method: "get",
      url: config.REACT_APP_ENV_API_BASE + "/tenantProvisioning/new",
      params: payload,
    })
      .then((res) => {
        if (res.data) callback(res.data);
      })
      .catch(() => {
        callback(null);
      });
  } catch (error) {
    callback(null);
  }
}

export const fetchTenantDetails = async (clientId: number): Promise<any> => {
  try {
    const response = await fetch(
      config.REACT_APP_ENV_API_BASE + `/templates/tenants/view/${clientId}`,
      // { headers: { "ngrok-skip-browser-warning": "69420" } }
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch tenant details for ID: ${clientId}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error fetching tenant details for ID ${clientId}:`, error);
    throw error;
  }
};

export const saveTenantChanges = async (
  tenantId: string, 
  body: Record<string, any>
): Promise<{ success: boolean; message: string; tenantId?: string; updatedClients?: string[] }> => {
  try {
    const response = await fetch(`${config.REACT_APP_ENV_API_BASE}/templates/tenants/${tenantId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        // Add any auth headers if needed
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `API returned ${response.status}`);
    }

    const data = await response.json();
    return {
      success: true,
      message: data.message || "Changes saved successfully",
      tenantId: data.tenantId,
      updatedClients: data.updatedClients
    };
  } catch (error: any) {
    console.error("Error saving tenant changes:", error);
    return {
      success: false,
      message: error.message || "Failed to save changes"
    };
  }
};


export function getAllClientsList(): Promise<Client[]> {
  return new Promise((resolve, reject) => {
    axios
      .get(config.REACT_APP_ENV_API_BASE + "/tenantProvisioning/tenants")
      .then((res) => {
        console.log("Raw API response:", res.data);

        let data = res.data;

        if (!data || typeof data !== "object") {
          console.warn("Unexpected API response format:", data);
          resolve([]);
          return;
        }

        let mappedData: Client[] = [];

        if (Array.isArray(data.tenants)) {
          mappedData = data.tenants.map((item: any) => ({
            // id: item.Id || "",
            clientId: item.ClientId || "",
            clientName: item.Client_Nm || "",
          }));
        }

        console.log("Final mapped data:", mappedData);
        resolve(mappedData);
      })
      .catch((error) => {
        console.error("API request failed:", error);
        reject(error);
      });
  });
}
